<div class="power-circle-container" [ngStyle]="{
    left: x + 'px',
    top: y + 'px'
  }">
  <svg [attr.width]="diameter + strokeWidth" [attr.height]="diameter + strokeWidth ">
<!-- Círculo interior (borde blanco) -->
<circle
  [attr.cx]="radius"
  [attr.cy]="radius"
  [attr.r]="label === 'red' ? radius - strokeWidth -2: radius - strokeWidth"
  [attr.stroke]="colorScale"
  [attr.stroke-width]="strokeWidth"
  fill="white"
  [title]="label"
/>

<!-- Círculo de fondo de progreso (gris claro, 100%) -->
<circle
  *ngIf="label === 'red'"
  [attr.cx]="radius"
  [attr.cy]="radius"
  [attr.r]="label === 'red' ? radius - 2 : radius"
  stroke="#ccc"
  [attr.stroke-width]="strokeWidth"
  fill="none"
  [attr.stroke-dasharray]="circumference"
  stroke-linecap="round"
  [attr.transform]="'rotate(-90, ' + radius + ', ' + radius + ')'"
  stroke-dashoffset="0"
/>

<!-- Círculo de progreso real (valor actual) -->
<circle
  *ngIf="label === 'red' && displayValue > 0"
  [attr.cx]="radius"
  [attr.cy]="radius"
  [attr.r]="label === 'red' ? radius - 2 : radius"
  [attr.stroke]="progressColor"
  [attr.stroke-width]="strokeWidth"
  fill="none"
  [attr.stroke-dasharray]="circumference"
  [attr.stroke-dashoffset]="dashOffset"
  stroke-linecap="round"
  [attr.transform]="'rotate(-90, ' + radius + ', ' + radius + ')'"
/>


<!-- Coche -->
<g *ngIf="label === 'car'"
  [attr.transform]="'translate(' + radius + ',' + (radius - 25) + ') scale(' + (iconScale / 1.5) + ')'">
  <path [attr.transform]="'translate(-256, -256)'" fill="black"
        d="M135.2 117.4L109.1 192l293.8 0-26.1-74.6C372.3 104.6 360.2 96 346.6 96L165.4 96c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32l181.2 0c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2l0 144 0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48L96 400l0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48L0 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" />
</g>

<text *ngIf="label === 'car'"
  [attr.x]="radius"
  [attr.y]="radius + 5"
  text-anchor="middle"
  alignment-baseline="middle"
  fill="#000"
  font-size="22"
  [title]="label">
    {{ displayValue / 1000 | number:'1.0-2' }}
</text>
<text *ngIf="label === 'car'"
  [attr.x]="radius"
  [attr.y]="radius + 25"
  text-anchor="middle"
  alignment-baseline="middle"
  fill="#000"
  font-size="13">
    kW
 </text>

<!-- Home -->
<g *ngIf="label === 'home'"
      [attr.transform]="'translate(' + radius + ',' + (radius - 25) + ') scale(' + (iconScale / 1.5) + ')'">
  <path [attr.transform]="'translate(-288, -256)'" fill="black"
        d="M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
</g>
  <text *ngIf="label === 'home'"
    [attr.x]="radius"
    [attr.y]="radius + 5"
    text-anchor="middle"
    alignment-baseline="middle"
    fill="#000"
    font-size="22"
    [title]="label">
      {{ displayValue / 1000 | number:'1.0-2' }}
  </text>
  <text *ngIf="label === 'home'"
      [attr.x]="radius"
      [attr.y]="radius + 25"
      text-anchor="middle"
      alignment-baseline="middle"
      fill="#000"
      font-size="13">
      kW
   </text>


    <!-- Red eléctrtica -->
<g *ngIf="label === 'red'"
    [attr.transform]="'translate(' + radius + ',' + (radius - 16) + ') scale(1)'">
  <path [attr.transform]="'translate(-12, -20)'" fill="black"
        d="M8.28,5.45L6.5,4.55L7.76,2H16.23L17.5,4.55L15.72,5.44L15,4H9L8.28,5.45M18.62,8H14.09L13.3,5H10.7L9.91,8H5.38L4.1,10.55L5.89,11.44L6.62,10H17.38L18.1,11.45L19.89,10.56L18.62,8M17.77,22H15.7L15.46,21.1L12,15.9L8.53,21.1L8.3,22H6.23L9.12,11H11.19L10.83,12.35L12,14.1L13.16,12.35L12.81,11H14.88L17.77,22M11.4,15L10.5,13.65L9.32,18.13L11.4,15M14.68,18.12L13.5,13.64L12.6,15L14.68,18.12Z" />
</g>
  <text *ngIf="label === 'red'"
    [attr.x]="radius"
    [attr.y]="radius + 5"
    text-anchor="middle"
    alignment-baseline="middle"
    fill="#000" font-size="22"
    [title]="label">
      {{ displayValue / 1000 | number:'1.0-2' }}
  </text>
  <text *ngIf="label === 'red'"
      [attr.x]="radius"
      [attr.y]="radius + 25"
      text-anchor="middle"
      alignment-baseline="middle"
      fill="#000"
      font-size="13">
      kW
  </text>


    <!-- Bola centro -->
<g *ngIf="label === 'centro' && icon === 'sin solar'"
      [attr.transform]="'translate(' + radius + ',' + radius + ') rotate(45 0 0) scale(' + iconScale/ 1.2 + ')'">
    <path [attr.transform]="'translate(' + (-256) + ',' + (-256) + ')'" fill="black"
        d="M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4L224 224l-114.7 0 9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L224 288l0 114.7-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4L288 288l114.7 0-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L288 224l0-114.7 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z" />
</g>

<g *ngIf="label === 'centro' && icon === 'solar-panel'"
   [attr.transform]="'translate(' + radius + ',' + radius + ') scale(' + iconScale/1.2 + ')'">
  <path
    [attr.transform]="'translate(' + (-320) + ',' + (-256) + ')'"
    fill="black"
    d="M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384l217 0 0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64 217 0c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0L122.2 0zM260.9 64l118.2 0 10.4 104-139 0L260.9 64zM202.3 168l-100.8 0L122.2 64l90.4 0L202.3 168zM91.8 216l105.6 0L187.1 320 71 320 91.8 216zm153.9 0l148.6 0 10.4 104-169.4 0 10.4-104zm196.8 0l105.6 0L569 320l-116 0L442.5 216zm96-48l-100.8 0L427.3 64l90.4 0 31.4-6.3L517.8 64l20.8 104z"/>
</g>

<g *ngIf="label === 'centro' && icon === 'eco'"
   [attr.transform]="'translate(' + radius + ',' + radius + ') ' +     'scale(' + (iconScale/1.2 * 21.333) + ')'  ">
  <path
    [attr.transform]="'translate(-12,-12)'"
    fill="black"
    d="M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z"/>
</g>


    <!-- Solar  -->
  <g *ngIf="label === 'solar'"
      [attr.transform]="'translate(' + radius + ',' + (radius - 25) + ') scale(' + iconScale / 1.5 + ')'">
    <path
      [attr.transform]="'translate(-256, -256)'"
      fill="black"
      d="M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z" />
  </g>

  <text *ngIf="label === 'solar'"
    [attr.x]="radius"
    [attr.y]="radius + 5"
    text-anchor="middle"
    alignment-baseline="middle"
    fill="#000"
    font-size="22">
      {{ displayValue / 1000 | number:'1.0-2' }}
  </text>
  <text *ngIf="label === 'solar'"
    [attr.x]="radius"
    [attr.y]="radius + 25"
    text-anchor="middle"
    alignment-baseline="middle"
    fill="#000"
    font-size="13">
      kW
  </text>

    <!-- Battery  -->
  <g *ngIf="label === 'battery'"
      [attr.transform]="'translate(' + radius + ',' + (radius - 25) + ') scale(' + iconScale/1.5 + ')'">
    <path
      [attr.transform]="'translate(-288, -256)'"
      fill="black"
      d="M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm368 96L96 192l0 128 352 0 0-128z" />
  </g>
    <text *ngIf="label === 'battery'"
      [attr.x]="radius"
      [attr.y]="radius + 5"
      text-anchor="middle"
      alignment-baseline="middle"
      fill="#000"
      font-size="22"
      [title]="label">
      {{ displayValue / 1000 | number:'1.0-2' }}
    </text>
    <text *ngIf="label === 'battery'"
      [attr.x]="radius"
      [attr.y]="radius + 25"
      text-anchor="middle"
      alignment-baseline="middle"
      fill="#000"
      font-size="13">
      kW
    </text>

  </svg>
</div>
